import { useEffect } from "react";

// Injects a JSON-LD <script> into <head> for the lifetime of the component.
export default function Seo({ schema, id = "page-jsonld" }) {
  useEffect(() => {
    if (!schema) return undefined;
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(schema);
    document.head.appendChild(el);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [schema, id]);
  return null;
}
